export default __webpack_public_path__ + "static/media/sapphire1.4e0b7a23.jpg";